import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { userContext } from "../../Contexts/userContext";
import { transactionsURL } from "../../Hooks/URL";
import Transactions from "../../Template/Home/Transactions/Transactions";

function TransactionsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const page = "transactions";

  const [transactions, setTransactions] = useState({});
  const { data, loading, error } = useFetch(transactionsURL);

  useEffect(() => {
    if (!loading && !error && data) {
      console.log(data);
      setTransactions(data?.data);
    }
  }, [data, loading, error]);

  return (
    <Transactions
      transactions={transactions}
      setTransactions={setTransactions}
      loading={loading}
      role={contextData?.role}
    />
  );
}

export default TransactionsPage;
